import React from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapper: {
    height: "100%",
    position: "relative",
  },
  buttonProgress: {
    position: "absolute",
    top: "50%",
    left: "50%",
    marginTop: -12,
    marginLeft: -12,
  },
}));
function ActionButton(props) {
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Button {...props} disabled={props.loading || props.disabled}>
        {props.children}
      </Button>
      {props.loading && (
        <CircularProgress className={classes.buttonProgress} size={24} />
      )}
    </div>
  );
}

export default ActionButton;
